import React from "react";
import about1 from "../../../assets/images/thumb1.jpg";
import about2 from "../../../assets/images/thumb2.jpg";
import "./About.css";
import idea from '../../../assets/images/idea.png'
import social from '../../../assets/images/social.png'
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid about-bg">

          <div className="row">
          <div className="col-md-6 about-image">
            <div className="image-wrapper">
              <img src={about1} alt="" className="image1" />
              <img src={about2} alt="" className="image2" />
            </div>
          </div>
          <div className="col-md-6 about-us">
            <div className="about-wrapper">
              <h2 className="about-title">Who We Are</h2>
              <p>
                Founded with a vision to offer immaculate software solutions for
                companies, on time, within budget, and in accordance with their
                requirements. We are Small enough to be agile and nimble through
                a disciplined and consistent process, yet big enough to
                accommodate a wide range of customer needs.
              </p>
              <ul>
                <li style={{display:'flex',gap:'20px'}}>
                  <img src={idea} alt="tech" style={{objectFit:'contain'}}/>
                  <div>
                    <h4 style={{fontFamily: 'Oxanium, serif'}}>Innovation Driven</h4>
                    <p style={{fontFamily:'poppins, serif'}}>
                      SaaSpire combines innovation, expertise, and technology to
                      serve the community.
                    </p>
                  </div>
                </li>
                <li style={{display:'flex',gap:'20px'}}>
                <img src={social} alt="tech" style={{objectFit:'contain'}}/>
                  <div>
                    <h4 style={{fontFamily: '"Oxanium", serif'}}>Community Focused</h4>
                    <p style={{fontFamily:'poppins, serif'}}>
                      SaaSpire combines innovation, expertise, and technology to
                      serve the community.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <button onClick={() => navigate('/about')}>Read More</button>

          </div>
        </div>
       
        
      </div>
    </>
  );
};

export default About;
